import React from 'react';
import Icon from 'components/Icon';

require('style/Tabs');

export default class Tabs extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      active: 0
    };
  }

  render() {
    return (
      <div className="Tabs">
        <Buttons
          items={this.props.children.map((child) => child.props)}
          active={this.state.active}
          controls={this.props.controls}
          onClick={(index) => {
            this.setState({active: index});
            if (this.props.onChange) {
              this.props.onChange(this.props.children[index].props.id);
            }
          }}
        />
        {this.props.children[this.state.active]}
      </div>
    );
  }
}

class Buttons extends React.Component {

  render() {
    const Button = (props) => (
      <button onClick={() => this.props.onClick(props.id)} title={props.title} className={props.active ? 'active' : null}>
        <Icon icon={props.icon} color={props.color}/>
        <div>{props.title}</div>
      </button>
    );

    return (
      <div className="EditButtons">
        {
          this.props.items.map((item, idx) => (
            <Button key={idx} id={idx} title={item.title} icon={item.icon} color={item.color} active={idx === this.props.active} />
          ))
        }
        {this.props.controls && <div className="controls">{this.props.controls}</div>}
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./client/components/Tabs.js